($ => {

    /**
     * Sincroniza a classe "checked" dos checkboxes personalizados da aplicação com o
     * estado real do input — usado tanto no site quanto no admin.
     */
    $(() => {
        $(".check-input-field :checked").each(function() {
            $(this).parent(".check-input-field").addClass("checked");
        });
    });

    $(document).on("change", ".check-input-field", function() {
        if ($(":checked", this).length) {
            $(this).addClass("checked");
        } else {
            $(this).removeClass("checked");
        }
    });
})(jQuery);
